import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';


import * as actionsUi from './einstellungen.actions.ui';
import {Benutzer, BenutzerEinstellungen} from '../../clients/benutzerverwaltung';
import {GET_BENUTZER_EINSTELLUNGEN_ADMIN, GET_BENUTZER_EINSTELLUNGEN_ADMIN_ERFOLGREICH, GET_BENUTZER_EINSTELLUNGEN_ADMIN_FEHLER, GET_BENUTZER_LISTE, GET_BENUTZER_LISTE_ERFOLGREICH, GET_BENUTZER_LISTE_FEHLER, GetBenutzerEinstellungenAdminAction, GetBenutzerEinstellungenAdminErfolgreichAction, GetBenutzerListeErfolgreichAction} from '../../client-ngrx/benutzerverwaltung';
import {BENUTZER_SELEKTIERT, BenutzerSelektiertAction} from './einstellungen.actions.ui';
import {ListInputItem} from '../shared/sopi-list/sopi-list.model';
import {DisplayBenutzerPipe} from '../shared/pipes/displayBenutzer.pipe';

export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    benutzerListe: Array<Benutzer>;
    benutzerListeLaden: boolean;
    benutzerListeFehler: boolean;

    selectedBenutzer: Benutzer;

    benutzerEinstellungen: BenutzerEinstellungen;
    benutzerEinstellungenLaden: boolean;
    benutzerEinstellungenFehler: boolean;
}

export const initialPageState: PageState = {
    benutzerListe: [],
    benutzerListeLaden: false,
    benutzerListeFehler: false,

    selectedBenutzer: null,

    benutzerEinstellungen: null,
    benutzerEinstellungenLaden: false,
    benutzerEinstellungenFehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction>action;

            return Object.assign({}, state, <PageState>initialPageState);
        }

        case GET_BENUTZER_LISTE: {
            return Object.assign({}, state, <PageState> {
                benutzerListeLaden: true,
                benutzerListeFehler: false
            });
        }

        case GET_BENUTZER_LISTE_ERFOLGREICH: {
            const a = <GetBenutzerListeErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                benutzerListe: a.payload,
                benutzerListeLaden: false,
                benutzerListeFehler: false
            });
        }

        case GET_BENUTZER_LISTE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                benutzerListeLaden: false,
                benutzerListeFehler: true
            });
        }

        case BENUTZER_SELEKTIERT: {
            const a = <BenutzerSelektiertAction>action;

            return Object.assign({}, state, <PageState>{
                selectedBenutzer: a.payload
            });
        }

        case GET_BENUTZER_EINSTELLUNGEN_ADMIN: {
            return Object.assign({}, state, <PageState> {
                benutzerEinstellungenLaden: true,
                benutzerEinstellungenFehler: false
            });
        }

        case GET_BENUTZER_EINSTELLUNGEN_ADMIN_ERFOLGREICH: {
            const a = <GetBenutzerEinstellungenAdminErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                benutzerEinstellungen: a.payload,
                benutzerEinstellungenLaden: false,
                benutzerEinstellungenFehler: false
            });
        }

        case GET_BENUTZER_EINSTELLUNGEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState> {
                benutzerEinstellungenLaden: false,
                benutzerEinstellungenFehler: true
            });
        }

        default: {
            return state;
        }
    }


}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('EinstellungenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getBenutzerListe = createSelector(getPageState, (state: PageState) => {
    return state.benutzerListe
        .map((benutzer) => <ListInputItem>{
            groupId: null,
            groupTitle: null,
            itemId: benutzer.benutzer_id,
            itemTitle: DisplayBenutzerPipe.getDisplayBenutzerText(benutzer.benutzer_id, benutzer, 1),
            item: benutzer,
        });
});
export const getBenutzerListeLaden = createSelector(getPageState, (state: PageState) => state.benutzerListeLaden);
export const getBenutzerListeFehler = createSelector(getPageState, (state: PageState) => state.benutzerListeFehler);

export const getSelectedBenutzer = createSelector(getPageState, (state: PageState) => state.selectedBenutzer);

export const getBenutzerEinstellungen = createSelector(getPageState, (state: PageState) => state.benutzerEinstellungen);
export const getBenutzerEinstellungenLaden = createSelector(getPageState, (state: PageState) => state.benutzerEinstellungenLaden);
export const getBenutzerEinstellungenFehler = createSelector(getPageState, (state: PageState) => state.benutzerEinstellungenFehler);
